import React from 'react';
import { PageLeadBlockEditForm } from '../form/PageLeadBlockEditForm';
import { PageLeadDefault } from '../../../_lib/components/PageLead';

type PageLeadBlockEditProps = {
  title: string;
} & PageLeadBlockEditForm;

export function PageLeadBlockEditView({ title, form }: PageLeadBlockEditProps) {
  return (
    <>
      <PageLeadDefault title={title} leadText={undefined} invisible />
      <PageLeadBlockEditForm form={form} />
    </>
  );
}
